export default {"src":"/_next/static/media/original sans.36f80dc9.svg","height":68,"width":873};